export default "__VITE_ASSET__Cbc8Krj6__"